import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';
import { useTranslation } from 'react-i18next';

export interface EndModalProps {
  isOpen: boolean;
  onClose: () => void;
  quizSuccess: boolean;
  quizScore: number;
  quizzesExist: boolean;
}

const EndModal = (props: EndModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={props.isOpen} onOpenChange={props.onClose}>
      <ModalContent>
        <>
          <ModalHeader className="flex flex-col gap-1">{t('end_modal.end_title')}</ModalHeader>
          <ModalBody>
            <div>
              <p>
                {t('end_modal.end_message')} <br />
                {props.quizzesExist &&
                  (props.quizSuccess
                    ? t('end_modal.quiz_successfull') + props.quizScore
                    : t('end_modal.quiz_unsuccessfull'))}
              </p>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="cursor-pointer"
              color="danger"
              variant="light"
              onPress={props.onClose}
            >
              Close
            </Button>
          </ModalFooter>
        </>
      </ModalContent>
    </Modal>
  );
};

export default EndModal;
